<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconShield_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M6.263 18.012C7.77 20.087 9.683 21.418 12 22c2.317-.583 4.23-1.913 5.738-3.988S20 13.633 20 11.1V5l-8-3-8 3v6.1c0 2.533.754 4.838 2.263 6.912Zm9.34-9.806a.703.703 0 1 1 .995.996l-5.592 5.591a.704.704 0 0 1-.996 0L7.207 11.99a.703.703 0 1 1 .995-.996l2.306 2.307 5.095-5.095Z"
        clip-rule="evenodd"
    />
</svg>
